import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const TermsPage = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          Terms & Conditions
        </h1>
        <p className="text-gray-600 mb-8">Last updated: January 2026</p>

        <Card>
          <CardContent className="p-8 prose prose-emerald max-w-none">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Flippy Homes (flippyhomes.co.za), you accept and agree to be bound 
              by these Terms and Conditions. If you do not agree, please do not use our services.
            </p>

            <h2>2. Description of Service</h2>
            <p>
              Flippy Homes is an online property marketplace that connects property buyers, sellers, 
              renters, agents, and home service contractors in South Africa. We provide a platform 
              for listing and discovering properties and services.
            </p>

            <h2>3. User Accounts</h2>
            <ul>
              <li>You must provide accurate and complete information when registering</li>
              <li>You are responsible for maintaining the confidentiality of your account</li>
              <li>You must be at least 18 years old to use our services</li>
              <li>One person may only operate one account</li>
            </ul>

            <h2>4. Property Listings</h2>
            <ul>
              <li>All listings must be accurate and not misleading</li>
              <li>You must have the right to list the property</li>
              <li>Images must be genuine photos of the property</li>
              <li>Flippy Homes reserves the right to remove listings that violate our policies</li>
            </ul>

            <h2>5. Prohibited Activities</h2>
            <p>Users may not:</p>
            <ul>
              <li>Post false or misleading information</li>
              <li>Use the platform for fraudulent purposes</li>
              <li>Harass other users</li>
              <li>Scrape or copy our content without permission</li>
              <li>Attempt to circumvent our security measures</li>
            </ul>

            <h2>6. Fees and Payments</h2>
            <ul>
              <li>Subscription fees are billed monthly</li>
              <li>All prices are in South African Rand (ZAR)</li>
              <li>Refunds are handled on a case-by-case basis</li>
              <li>We reserve the right to change pricing with notice</li>
            </ul>

            <h2>7. Intellectual Property</h2>
            <p>
              All content on Flippy Homes, including logos, text, graphics, and software, is our 
              property or licensed to us. You may not use our intellectual property without permission.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p>
              Flippy Homes is a platform connecting users. We do not guarantee the accuracy of listings, 
              the quality of services, or the outcome of any transactions. We are not liable for:
            </p>
            <ul>
              <li>Disputes between users</li>
              <li>Inaccurate property information</li>
              <li>Quality of contractor services</li>
              <li>Financial losses from transactions</li>
            </ul>

            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify and hold Flippy Homes harmless from any claims, damages, or 
              expenses arising from your use of the platform or violation of these terms.
            </p>

            <h2>10. Termination</h2>
            <p>
              We may terminate or suspend your account at any time for violation of these terms. 
              You may close your account at any time by contacting us.
            </p>

            <h2>11. Governing Law</h2>
            <p>
              These terms are governed by the laws of the Republic of South Africa. Any disputes 
              will be resolved in South African courts.
            </p>

            <h2>12. Contact</h2>
            <p>
              For questions about these terms, contact us at:<br/>
              Email: legal@flippyhomes.co.za<br/>
              WhatsApp: +27 65 524 9286
            </p>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default TermsPage;
